'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _ManageDataSource = require('../components/ManageDataSource');

var _ManageDataSource2 = _interopRequireDefault(_ManageDataSource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {};
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_ManageDataSource2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/o2o/lib/modules/ManageDataSource/containers/ManageDataSourceContainer.js
// module id = 4011
// module chunks = 9